module.exports = __webpack_public_path__ + "static/onyedikachi-f9a3fb0329c6acac0a7f33bd064b8206.jpg";